


































import { Component, Vue } from 'vue-property-decorator'

import firebase from 'firebase/app'
import 'firebase/auth'

@Component
export default class SignIn extends Vue {
  email = ''
  password = ''

  loading = false

  errorMessage: string | null = null

  signIn(): void {
    const email = this.email
    const password = this.password

    // Guard email and password lengths
    if (email.length < 5 || password.length < 2) {
      return
    }

    this.loading = true
    this.errorMessage = null

    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then((userCredential: { user: unknown }) => {
        // Signed in

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const _user = userCredential.user

        window.flash('Signed in!')
        // console.log('Signed in!', _user)
      })
      .catch((error: { code: string; message: string }) => {
        // console.error('Failed to sign in', error.code, error.message)

        window.flash(error.message || 'Failed to sign in', 'error')
        this.errorMessage = error.message
      })
      .finally(() => {
        this.loading = false
      })
  }

  resetPasswordEmail(): void {
    const email = this.email

    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(() => {
        // Password reset email sent!
        // ..
        // console.log('Password reset email sent')
        window.flash('Password reset email sent')
      })
      .catch((error: { code: string; message: string }) => {
        // console.error('Failed to send password reset email', error.code, error.message)

        this.errorMessage = error.message
      })
  }
}
